
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40 76.96c20.413 0 36.96-16.547 36.96-36.96C76.96 19.588 60.413 3.04 40 3.04 19.588 3.04 3.04 19.588 3.04 40c0 20.413 16.548 36.96 36.96 36.96z","fill":"#DBF2FF"}}),_c('path',{attrs:{"d":"M30.08 16.48h34.96c.88 0 1.6.72 1.6 1.6v2.72c0 .88-.72 1.6-1.6 1.6H30.08c-.88 0-1.6-.72-1.6-1.6v-2.64c0-.96.72-1.68 1.6-1.68z","fill":"#15004B"}}),_c('path',{attrs:{"d":"M19.68 13.6v8.8h2.96v2.88h-8.8V22.4h2.88v-5.92h-2.88V13.6h5.84z","fill":"#00D7C2"}}),_c('path',{attrs:{"d":"M13.84 45.84v-7.36h5.84v-1.44h-5.84v-2.96h8.8v7.36h-5.92v1.44h5.92v2.96h-8.8z","fill":"#004ADB"}}),_c('path',{attrs:{"d":"M19.68 62h-5.84v-2.96h5.84V57.6h-5.84v-2.96h8.8V66.4h-8.8v-2.96h5.84V62z","fill":"#8D05FB"}}),_c('path',{attrs:{"d":"M30.08 37.04h34.96c.88 0 1.6.72 1.6 1.6v2.64c0 .88-.72 1.6-1.6 1.6H30.08c-.88 0-1.6-.72-1.6-1.6v-2.64c0-.88.72-1.6 1.6-1.6z","fill":"#15004B"}}),_c('path',{attrs:{"d":"M30.08 57.6h34.96c.88 0 1.6.72 1.6 1.6v2.64c0 .88-.72 1.6-1.6 1.6H30.08c-.88 0-1.6-.72-1.6-1.6V59.2c0-.88.72-1.6 1.6-1.6z","fill":"#15004B"}})])
          )
        }
      }
    